import React from "react";

export default class SearchSort extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownVisible: false,
    };

    this.onToggleDropdown = this.onToggleDropdown.bind(this);
    this.onChangeSort = this.onChangeSort.bind(this);
  }

  render() {
    return (
      <div className="search-sort">
        <div className="results">
          {this.numberWithCommas(this.props.total_count)} results for "
          {this.props.query}"
        </div>
        {this.props.total_pages === 0 ? null : (
          <div className="sorts">
            <div
              className="sort-dropdown"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  this.onToggleDropdown();
                }
              }}
              role="listbox"
              aria-label={I18n.t("sort_search_results_dropdown")}
              onClick={this.onToggleDropdown}
            >
              <div className="sort-dropdown-option">
                <span className="text">{this.printSort()}</span>{" "}
                <span className="fa fa-chevron-down"></span>
              </div>
              <div
                className={
                  "sort-dropdown-menu " +
                  (this.state.dropdownVisible ? "visible" : "")
                }
              >
                <div
                  className="sort-dropdown-item"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      this.onChangeSort("relevance");
                    }
                  }}
                  role="option"
                  aria-label="Relevance"
                  onClick={this.onChangeSort.bind(null, "relevance")}
                >
                  Relevance
                </div>
                <div
                  className="sort-dropdown-item"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      this.onChangeSort("last-modified");
                    }
                  }}
                  role="option"
                  aria-label="Last Modified"
                  onClick={this.onChangeSort.bind(null, "last-modified")}
                >
                  Last Modified
                </div>
                <div
                  className="sort-dropdown-item"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      this.onChangeSort("alphabetical-a-z");
                    }
                  }}
                  role="option"
                  aria-label="Alphabetical A-Z"
                  onClick={this.onChangeSort.bind(null, "alphabetical-a-z")}
                >
                  Alphabetical A-Z
                </div>
                <div
                  className="sort-dropdown-item"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      this.onChangeSort("alphabetical-z-a");
                    }
                  }}
                  role="option"
                  aria-label="Alphabetical Z-A"
                  onClick={this.onChangeSort.bind(null, "alphabetical-z-a")}
                >
                  Alphabetical Z-A
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  /*
   * Change handlers
   */

  onChangeSort(sort) {
    this.props.onChangeSort(sort);
    this.setState({ dropdownVisible: !this.state.dropdownVisible });
  }

  onToggleDropdown() {
    var self = this;
    this.setState(
      { dropdownVisible: !this.state.dropdownVisible },
      function () {
        if (self.state.dropdownVisible) {
          $(window).on("click.searchDropown", function (e) {
            var $target = $(e.target);
            if (
              $target.hasClass("sort-dropdown") ||
              $target.hasClass("sort-dropdown-item") ||
              $target.hasClass("sort-dropdown-option") ||
              $target.hasClass("text") ||
              $target.hasClass("fa")
            ) {
              return;
            }
            self.setState({ dropdownVisible: false });
            $(window).off("click.searchDropown");
          });
        } else {
          $(window).off("click.searchDropown");
        }
      }
    );
  }

  /*
   * Helper functions
   */

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  printSort() {
    if (this.props.sort === "relevance") {
      return "Relevance";
    } else if (this.props.sort === "last-modified") {
      return "Last Modified";
    } else if (this.props.sort === "alphabetical-a-z") {
      return "Alphabetical A-Z";
    } else if (this.props.sort === "alphabetical-z-a") {
      return "Alphabetical Z-A";
    }
  }
}
